module.exports = __webpack_public_path__ + "6b2cd5709dbd046ed6137070a62e58ed.png";